<template>
  <el-tooltip
    :popper-class="className"
    placement="top"
  >
    <div slot="content">
      <p v-html="tooltipCon" />
      <!-- <p >{{tooltipCon}}</p> -->
    </div>
    <img
      :class="imgClassName"
      src="../../assets/hovertip.svg"
      alt=""
    >
  </el-tooltip>
</template>

<script>
export default {
name: 'Tooltip',
props:{
    tooltipCon:{
        type: String,
        default:''
    },
    className:{
        type: String,
        default:'ye-vr'  
    },
    imgClassName:{
        type: String,
        default:'imgTip'  
    }
},
}
</script>

<style scoped lang="scss">

</style>
